var index = {
  root: {
    outline: {
      width: '2px',
      color: '{content.background}'
    }
  }
};

export { index as default };
//# sourceMappingURL=index.mjs.map
